import { updateToken } from '@hobs/auth/actions';
import { actionCreator } from './utils/utils';
import {
  FORSUBMIT,
  GET,
  CREATE,
  PATCHPARTY,
  UPDATE,
  CLEAR,
  CHANGEPASSWORD,
  RESENDRESETPASSWORD,
  CHANGELOCKSTATUS,
  SOFTDELETEUSER,
  GET_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_PERIODIC_INFO,
  GET_CURRENT
} from '@hobs/constants/users';
import { _fetch as fetchSecure } from '@hobs/utils/fetch';

const PARTY_USER_TYPES = {
  1: 'HnUsers',
  2: 'SnUsers',
  3: 'SpUsers'
};

function getActionUrl(partyType, url = '') {
  if (!PARTY_USER_TYPES[partyType]) {
    throw new Error('PartyType not provided');
  }

  return `${PARTY_USER_TYPES[partyType]}/${url}`;
}

export const getUserForSubmit = partyType =>
  actionCreator(getActionUrl(partyType, 'forSubmit'), FORSUBMIT);

export const createUser = (partyType, user) =>
  actionCreator(getActionUrl(partyType), CREATE, {
    body: user,
    method: 'Post'
  });

export const changeUserParty = (partyType, userId, partyId) =>
  actionCreator(
    getActionUrl(partyType, `${userId}/Parties/${partyId}`),
    PATCHPARTY,
    { method: 'PATCH' }
  );

export const getUser = (partyType, userId) =>
  actionCreator(getActionUrl(partyType, userId), GET);

export const updateUser = (partyType, user) =>
  actionCreator(getActionUrl(partyType), UPDATE, { body: user, method: 'PUT' });

export const changePassword = (partyType, userId, password) =>
  actionCreator(
    getActionUrl(partyType, `${userId}/ChangePassword`),
    CHANGEPASSWORD,
    { body: password, method: 'POST' }
  );

export const resendResetPassword = (partyType, userId) =>
  actionCreator(
    getActionUrl(partyType, `${userId}/ResendResetEmail`),
    RESENDRESETPASSWORD,
    { method: 'POST' }
  );

export const changeLockStatus = (partyType, userId, lockStatus) =>
  actionCreator(
    getActionUrl(partyType, `${userId}/changeLockStatus`),
    CHANGELOCKSTATUS,
    { body: lockStatus, method: 'POST' }
  );

export const softDeleteUser = (userId, partyType) => {
  const uri = partyType
    ? getActionUrl(partyType, `${userId}/soft-delete`)
    : `Users/${userId}/soft-delete`;

  return actionCreator(uri, SOFTDELETEUSER, { method: 'DELETE' });
};

export function clearUser() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export const getCurrentUserNotificationSettings = () =>
  actionCreator('Users/NotificationsSettings', GET_NOTIFICATION_SETTINGS);

export const updateCurrentUserNotificationSettings = settings =>
  actionCreator('Users/NotificationsSettings', UPDATE_NOTIFICATION_SETTINGS, {
    method: 'POST',
    body: settings
  });

export function updatePeriodicInfo(values) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Account/UpdatePeriodicInfo', {
      body: values,
      method: 'PUT'
    })
      .then(response => {
        if (response.payload && response.payload.token) {
          dispatch(updateToken(response.payload.token));
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATE_PERIODIC_INFO.REQUEST };
  }
  function success() {
    return { type: UPDATE_PERIODIC_INFO.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE_PERIODIC_INFO.FAILURE, error };
  }
}

export const getCurrentUser = partyType =>
  actionCreator(getActionUrl(partyType, 'Current'), GET_CURRENT);
